module.exports = __webpack_public_path__ + "static/4-76cf620820dfa675a9b0e95a18346ea4.jpg";